'use client';
import { SessionContext } from '@benzinga/session-context';
import { noop } from '@benzinga/utils';
import { WidgetLinkingID, WidgetLinkingManager } from '@benzinga/widget-linking';
import React from 'react';
import { useGroupEditModal } from './GroupEditModal';
import { GroupSelectDropdown } from './GroupSelectDropdown';

export interface WidgetLinkingPickerProps {
  group: WidgetLinkingID;
  isOpen?: boolean;
  position?: 'bottom' | 'left' | 'right';
  onClose?: () => void;
  onGroupChange: (sendGroupId: WidgetLinkingID) => void;
}

interface WidgetLinkingPickerState {
  isOpenSelectDropdown: boolean;
}

export const WidgetLinkingPicker: React.FC<WidgetLinkingPickerProps> = props => {
  const session = React.useContext(SessionContext);
  const linkingManager = session.getManager(WidgetLinkingManager);
  const [state, setState] = React.useState<WidgetLinkingPickerState>({
    isOpenSelectDropdown: false,
  });
  const { editGroup, renderModal } = useGroupEditModal(g => {
    linkingManager.saveWidgetLink(g);
  });

  React.useEffect(() => {
    setState(s => ({ ...s, isOpenSelectDropdown: props.isOpen ?? false }));
  }, [props.isOpen]);

  const selectGroupID = (groupId: WidgetLinkingID) => {
    props.onGroupChange(groupId);
    props.onClose?.();
    return;
  };

  return (
    <>
      <GroupSelectDropdown
        editGroup={editGroup}
        group={props.group}
        onClose={props.onClose ?? noop}
        open={state.isOpenSelectDropdown}
        position={props.position}
        selectGroupID={selectGroupID}
      />
      {renderModal()}
    </>
  );
};
